module.exports = __webpack_public_path__ + "img/1503276952.af5f982d.jpg";